export default "__VITE_ASSET__BfjW0HIc__"